import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TablePictureEnum, TableTypeConfigModel } from 'src/app/pos-panel/enums/table-picture.enum';
import { CreateOrEditCapacityModel } from 'src/app/pos-panel/models/tables/create-or-edit-capacity.model';
import { TableGroupModel } from 'src/app/pos-panel/models/tables/table-group.model';
import { TableTypeModel } from 'src/app/pos-panel/models/tables/table-type.model';
import { VenueService } from "../../../services/venues/venue.service";
import {
  CdkDragStart,
  CdkDragMove,
  CdkDragDrop,
  moveItemInArray,
  copyArrayItem,
} from '@angular/cdk/drag-drop';
import { DivisionModel } from "../../../models/divisions/division.model";
import { DeleteGroupDialogComponent } from "./delete-group-dialog/delete-group-dialog.component";


@Component({
  selector: 'app-create-capacity-for-venues',
  templateUrl: './create-capacity-for-venues.component.html',
  styleUrls: ['./create-capacity-for-venues.component.scss']
})
export class CreateCapacityForVenuesComponent implements OnInit {

  //#region Fields
  public dragedTable: TableTypeModel;
  public tablePicture: Array<TableTypeModel> = new Array<TableTypeModel>();
  public startX: string;
  public startY: string;
  public tableGroups: Array<TableGroupModel> = new Array<TableGroupModel>();
  public selectedGroup: TableGroupModel = new TableGroupModel();
  public addTableGroup: TableGroupModel;
  public showAddGroup: boolean;
  public showUpdateGroup: boolean;
  public items: MenuItem[];
  public createOrEditCapacityModel: CreateOrEditCapacityModel = new CreateOrEditCapacityModel();
  public venueId: string;
  public enableEdit: boolean = false;
  public returnCapacityObject: boolean = false;
  public listDivisions: Array<DivisionModel> = new Array<DivisionModel>();

  //#endregion

  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public translate: TranslateService,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private venueService: VenueService,
    private confirmationService: ConfirmationService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.venueId = this.config.data.id;
    }
    if (this.config.data != undefined && this.config.data.returnCapacityObject) {
      this.returnCapacityObject = this.config.data.returnCapacityObject;
    }

    this.addTableGroup = new TableGroupModel();
    this.createOrEditCapacityModel.capacityGroups = new Array<TableGroupModel>();

    if (this.config.data != undefined && this.config.data.capacityConfig) {
      this.convertAndSetCapacity(this.config.data.capacityConfig);
    }
  }

  ngOnInit(): void {
    if (this.venueId) {
      this.listDivisionsForCurrentVenue();
    }
    const el = document.getElementsByClassName('p-dialog-mask');
    if(el[1] !=null){
      el[1].classList.add('justify-content-start-mbl')
    }
    else{
      el[0].classList.add('justify-content-start-mbl')
    }


    Object.entries(TablePictureEnum).filter(t => isNaN(+t)).forEach((tableType: string[]) => {
      let table = new TableTypeModel();
      table.type = tableType[0];
      table.shape = tableType[1];
      table.numberOfPeople = TableTypeConfigModel[tableType[0] as keyof typeof TableTypeConfigModel].value;
      this.tablePicture.push(table)
    });

    this.viewCapacity();
  }
  //#endregion

  //#region Public Methods
  openAddGroup() {
    this.showAddGroup = true;
  }

  closeAddGroup() {
    this.showAddGroup = false;
    this.showUpdateGroup = false;
    this.addTableGroup = new TableGroupModel();
  }

  addGroup() {
    if (this.addTableGroup.name) {
      this.selectedGroup = this.addTableGroup
      this.addTableGroup.index = this.createOrEditCapacityModel.capacityGroups.length !=0 ? Math.max(...this.createOrEditCapacityModel.capacityGroups.map(o => o.index)) + 1 : 1;
      this.addTableGroup.capacityTables = new Array<TableTypeModel>();
      this.createOrEditCapacityModel.capacityGroups.push(this.addTableGroup)
      this.addTableGroup = new TableGroupModel();
      this.showAddGroup = false;
    }
  }

  openUpdateGroup(model: TableGroupModel) {
    this.addTableGroup = model
    this.showAddGroup = true;
    this.showUpdateGroup = true;
  }

  updateGroup(model: TableGroupModel) {
    if (model.name) {
      this.createOrEditCapacityModel.capacityGroups.find(c => c.index === model.index )?.name === model.name;
      this.addTableGroup = new TableGroupModel();
      this.showAddGroup = false;
      this.showUpdateGroup = false;
    }
  }

  removeGroup(groupIndex: number) {
    const ref = this.dialogService.open(DeleteGroupDialogComponent, {
      styleClass: 'dialog_long dialog_groupDelete',
      showHeader: false
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        if (!this.isGroupDeleteDisabled(groupIndex)) {
          if (this.selectedGroup.index == groupIndex) {
            this.selectedGroup = new TableGroupModel()
          }
          this.createOrEditCapacityModel.capacityGroups = this.createOrEditCapacityModel.capacityGroups.filter(c => c.index !== groupIndex);
        }
      }
    });
  }

  dragStart(e: any, t: any) {
    this.startX = e.offsetX;
    this.startY = e.offsetY;
    this.dragedTable = new TableTypeModel();
    this.dragedTable = t;
    this.confirmationService.close();
  }

  dragEnd(e: any) {

  }

  drop(e: any) {
    if(this.createOrEditCapacityModel.capacityGroups.length == 0){

    }
    else if (this.dragedTable) {

      let table = new TableTypeModel();
      table.index = this.dragedTable.index;
      table.type = this.dragedTable.type;
      table.shape = this.dragedTable.shape;
      table.yPosition = this.dragedTable.yPosition;
      table.xPosition = this.dragedTable.xPosition;
      table.numberOfPeople = TableTypeConfigModel[this.dragedTable.type as keyof typeof TableTypeConfigModel].value;

      let top = ((parseInt(e.layerY)) - parseInt(this.startY));
      let left = ((parseInt(e.layerX)) - parseInt(this.startX));

      if ((top >= 80 && top <= 420) && (left >= 175 && left <= 920)) {
        table.yPosition = top + 'px';
        table.xPosition = left + 'px';
        if (this.selectedGroup.capacityTables.find(t => t.index === table.index)) {
          this.selectedGroup.capacityTables = this.selectedGroup.capacityTables.filter(t => t.index !== table.index);
        }
        else {
          table.index = this.selectedGroup.capacityTables.length + 1;
        }
        this.selectedGroup.capacityTables.push(table);
      }

      this.dragedTable = new TableTypeModel();
    }
  }

  editTable() {

  }
  deleteTable() {

  }

  onDoubleClick(event: any, table: any) {
    if ((table.status === undefined || table.status === null) || table.status === 1) {
      this.confirmationService.confirm({
        target: event.target,
        rejectVisible: false,
        acceptLabel: this.translate.instant("DELETE"),
        defaultFocus: 'reject',
        acceptButtonStyleClass: 'accept-button-style-class',
        accept: () => {
          //confirm action
          if (this.selectedGroup.capacityTables.find(t => t.index === table.index)) {
            this.selectedGroup.capacityTables = this.selectedGroup.capacityTables.filter(t => t.index !== table.index);
            this.selectedGroup.capacityTables.forEach((table, index) => table.index = index+1);
          }
        },
        reject: () => {
          //reject action
        }
      });
    } else {
      this.confirmationService.confirm({
        target: event.target,
        rejectVisible: false,
        acceptLabel: 'This table cannot be deleted',
        defaultFocus: 'reject',
        acceptButtonStyleClass: 'accept-message-style-class',
        accept: () => {
          //confirm action
        },
        reject: () => {
          //reject action
        }
      });
    }
  }

  save(model: CreateOrEditCapacityModel) {
    model.venueId = this.venueId;

    model.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = +x.xPosition.toString().replace('px', '');
        x.yPosition = +x.yPosition.toString().replace('px', '');
      });
    });

    if (!this.returnCapacityObject) {
      this.venueService.createcapacity(model)
        .subscribe({
          next: (response) => {
            this.ref.close(true);
          },
          error: errorResponse => {
            this.ref.close(false);
          }
        });
    } else {
      this.ref.close(model);
    }
  }

  updateOrDeleteCapacity(model: CreateOrEditCapacityModel) {
    model.venueId = this.venueId;

    model.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = +x.xPosition.toString().replace('px', '');
        x.yPosition = +x.yPosition.toString().replace('px', '');
      });
    });

    this.venueService.updateCapacity(model)
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.ref.close(false);
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }

  viewCapacity() {
    if (this.venueId) {
      this.venueService.viewVenueCapacity(this.venueId)
        .subscribe({
          next: (response: CreateOrEditCapacityModel) => {
            if (response) {
              this.enableEdit = true;
              this.convertAndSetCapacity(response);
            }
          },
          error: errorResponse => {
            if (errorResponse.error) {
            }
          }
        });
    }
  }

  convertAndSetCapacity(response: CreateOrEditCapacityModel): void {
    response.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = x.xPosition + 'px';
        x.yPosition = x.yPosition + 'px';
        const type = Object.keys(TablePictureEnum).find((y: string) => TablePictureEnum[y as keyof typeof TablePictureEnum] == x.shape);
        x.type = type ? type : '';
      });
    });
    this.createOrEditCapacityModel = response;
    if (this.createOrEditCapacityModel.capacityGroups.length > 0) {
      this.selectedGroup = this.createOrEditCapacityModel.capacityGroups[0];
    }
  }

  isGroupDeleteDisabled(groupIndex: number): boolean {
    let disabled = false;
    this.createOrEditCapacityModel.capacityGroups.find(c => c.index === groupIndex)?.capacityTables.forEach((table: TableTypeModel) => {
      if (table.status && table.status !== 1) {
        disabled = true;
      }
    });
    return disabled;
  }
  //#endregion

  //#region Mobile drag and drop
  @ViewChild('dropZone', { read: ElementRef, static: true })
  dropZone: ElementRef;

  _currentIndex: any;
  _currentField: any;
  isPointerOverContainer: boolean;
  _pointerPosition: { x: number; y: number; };

  // types = [{ text: 'drag me', top: 0, left: 0 }, { text: 'drag me2', top: 0, left: 0 }];

  // fields: any[] = [];

  moved(event: CdkDragMove) {
    this._pointerPosition = event.pointerPosition;
  }
  itemDropped(event: CdkDragDrop<any[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(this.selectedGroup.capacityTables, event.previousIndex, event.currentIndex);
    } else {
      event.item.data.yPosition =
        this._pointerPosition.y -
        this.dropZone.nativeElement.getBoundingClientRect().top +
        'px';
      event.item.data.xPosition =
        this._pointerPosition.x -
        this.dropZone.nativeElement.getBoundingClientRect().left +
        'px';
      this.addField({ ...event.item.data }, event.currentIndex);
    }
  }

  addField(fieldType: any, index: number) {
    this.selectedGroup.capacityTables.splice(index, 0, fieldType)
  }

  changePosition(event: CdkDragDrop<any>, field: any) {

    const rectZone=this.dropZone.nativeElement.getBoundingClientRect()
    const rectElement=event.item.element.nativeElement.getBoundingClientRect()

    let yPosition=+field.yPosition.replace('px','')+event.distance.y
    let xPosition=+field.xPosition.replace('px','')+event.distance.x

    const out=yPosition<0 || xPosition<0 || (yPosition>(rectZone.height-rectElement.height)) || (xPosition>(rectZone.width-rectElement.width))
    if (!out)
    {
       field.yPosition=yPosition+'px'
       field.xPosition=xPosition+'px'
    }
    else{
       this.selectedGroup.capacityTables=this.selectedGroup.capacityTables.filter(x=>x!=field)
    }
  }

  listDivisionsForCurrentVenue(): void {
    this.venueService.listVenueDivisions(this.venueId).subscribe({
        next: (response) => {
          this.listDivisions = response;
        }
      });
  }
  //#endregion
}
